module.exports = __webpack_public_path__ + "img/Check.6ac377c6.svg";